import { render, staticRenderFns } from "./NewsIndex.vue?vue&type=template&id=ba58e77e&"
import script from "./NewsIndex.vue?vue&type=script&lang=js&"
export * from "./NewsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports